import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function LessIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 8} height={height || 1.7} viewBox="0 0 8 1.7">
      <path
        data-name="Path 10005"
        d="M12.429 12.7H5.571c-.314 0-.571-.382-.571-.85s.257-.85.571-.85h6.857c.314 0 .571.382.571.85s-.256.85-.57.85z"
        transform="translate(-5 -11)"
        fill={color || "#555"}
      />
    </svg>
  );
}
